import type { EditAssetWorkflowOptions } from '../../types';

export const addScheduleEntryWorkflow: EditAssetWorkflowOptions = {
  workflowKey: 'addScheduleEntryWorkflow',
  workflowType: 'editAssetWorkflow',
  assetType: 'schedule',
  workflowIndex: 1,
  workflowName: 'Add Schedule Entry Workflow',
  workflowDescription: 'Add a schedule entry representing an FC schedule for a specific time in the future',
  workflowAssets: ['fulfillmentContext', 'schedule'],
  workflowStateTransformFunction: (assetPayload: any, asset: any) => {
    asset.entries = [...asset.entries, ...assetPayload.newEntry];
    return asset;
  },
  workflowStepOptions: [
    {
      workflowStepKey: 'scheduleEntryAdd',
      workflowStepNavigationName: 'Add a schedule',
      workflowComponent: {
        workflowComponentType: 'scheduleEntry',
        prompt: 'Add an entry to your schedule',
        description: '',
        help: 'Create a schedule entry for your fulfillment network. Essentially an operations calendar for an FC. You will be able to add additional future entries later.',
      },
      workflowStateToAssetMapping: {
        property: 'newEntry',
        mappingType: 'property',
      },
    },
    {
      workflowStepKey: 'summary',
      workflowStepNavigationName: 'Configuration Summary',
      workflowComponent: {
        workflowComponentType: 'workflowSummary',
        title: 'Add schedule Summary',
        description: 'The schedule will be created.  Please review your selections.',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'ignore',
      },
    },
  ],
};
